import { Suspense } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import { ScenariosByCategory } from "./scenarios-by-category";
import {
  ScenarioCategoriesList,
  scenariosCategoriesQuery,
} from "./categories-list";

export function Scenarios() {
  const { data } = useQuery(scenariosCategoriesQuery);
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category_id");
  const category = data?.categories.find((it) => it.id === categoryId);

  return (
    <div className="p-10 bg-white">
      <div className="py-5 mb-[10px]">
        <header className="px-5 mb-5">
          <h3 className="flex items-center gap-[10px] text-[#5B5B5B] font-alternative text-2xl font-semibold uppercase mb-1">
            Todos os cenários{" "}
            <span className="text-base leading-5 text-[#2D2D2D]">
              ({data?.total_scenarios})
            </span>{" "}
          </h3>
          <p className="text-[#646464] text-sm">
            Cenários possuem checklists e possibilidade de anexar vários exames
          </p>
        </header>

        <Suspense>
          <ScenarioCategoriesList />
        </Suspense>
      </div>

      <ScenariosByCategory
        category={category}
        className="p-5 rounded-[10px] bg-white shadow-card"
      />
    </div>
  );
}
